module.exports = {
    LOGIN: 'LOGIN',
    DO_ANSWER: 'DO_ANSWER',
    RECONNECT: 'RECONNECT',
    REGISTER: 'REGISTER',
    LOG_OUT : 'LOG_OUT',
    DELETE_USER: 'DELETE_USER',
}


// WEBPACK FOOTER //
// ./src/events/ClientToServer.js